import Icon, { ICON_SIZES } from "@/components/library/Icon";

import Button from "../library/Button";
import Markdown from "react-markdown";
import React from "react";
import clsx from "clsx";
import rehypeRaw from "rehype-raw";
import remarkGridPlugin from "./remark-grid-plugin";

function LinkRenderer(
  props: any,
  sendAction?: (title: string, action: string | null) => Promise<void>
) {
  const children = props.children;

  const isAction = children.startsWith("$$");

  if (isAction && sendAction) {
    const params = children.replace("$$", "").split(";");

    const icon = params.find((param: string) => param.startsWith("i:"));
    const title = params.find((param: string) => param.startsWith("t:"));
    const description = params.find((param: string) => param.startsWith("d:"));
    const action = params.find((param: string) => param.startsWith("a:"));
    const type = params.find((param: string) => param.startsWith("b:"));

    const iconName = icon ? icon.split(":")[1] : null;
    const titleName = title ? title.split(":")[1] : null;
    const actionName = action ? action.split(":")[1] : null;
    const descriptionName = description ? description.split(":")[1] : null;
    const typeName = type ? type.split(":")[1] : "tertiary";

    return (
      <Button
        type={typeName}
        onClick={() => sendAction(titleName, actionName)}
        disabled={!actionName}
      >
        {iconName && !titleName && (
          <Icon icon={iconName} size={3} className="m-auto" />
        )}
        {iconName && titleName && (
          <div className={clsx("grid", "grid-cols-[60px_1fr]", "text-left")}>
            <Icon icon={iconName} size={3} className="m-auto" />
            <div>
              <div className="font-semibold">{titleName}</div>
              {descriptionName && (
                <span className="text-sm">{descriptionName}</span>
              )}
            </div>
          </div>
        )}
        {!iconName && titleName && (
          <>
            <div className="font-semibold">{titleName}</div>
            {descriptionName && (
              <span className="text-sm">{descriptionName}</span>
            )}
          </>
        )}
      </Button>
    );
  }

  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {children}
      <Icon
        icon="arrow-up-right-from-square"
        size={ICON_SIZES.XXS}
        className="ml-1"
      />
    </a>
  );
}

const AskText: React.FC<{
  text: string;
  isMarkDown: boolean;
  sendAction?: (title: string, action: string | null) => Promise<void>;
}> = ({ text, isMarkDown, sendAction }) => {
  let mainComponent = isMarkDown ? (
    <Markdown
      className={clsx("[&_a]:underline", "[&_a]:text-primary", "mrkdwn")}
      components={{ a: (props) => LinkRenderer(props, sendAction) }}
      remarkPlugins={[remarkGridPlugin]}
      rehypePlugins={[rehypeRaw]}
    >
      {text}
    </Markdown>
  ) : (
    <div>{text}</div>
  );

  return <>{mainComponent}</>;
};

export default AskText;
